import { DDSButton, DDSModal, DDSTypography } from 'den-design-system'

import { Button } from '../../../../components/New/Button/Button'
import React from 'react'
import { SetStateAction } from 'react'
import pallete from '../../../../global/newPallete'

interface ModalFooterProps {
  primaryButtonText?: string
  secondaryButtonText?: string
  thirdButtonText?: string
  onYes?: () => any
  onNo?: () => any
  onThirdYes?: () => any
  primaryButtonDisabled?: boolean
  secondaryButtonDisabled?: boolean
  thirdButtonDisabled?: boolean
  loading?: boolean
}
const ModalFooter: React.FC<ModalFooterProps> = ({
  onYes,
  onNo,
  onThirdYes,
  primaryButtonText = '',
  secondaryButtonText = '',
  thirdButtonText = '',
  primaryButtonDisabled,
  secondaryButtonDisabled,
  thirdButtonDisabled,
  loading
}) => {
  return (
    <div className='flex flex-row gap-x-[10px] px-[24px] py-[16px] override-btn-min-width justify-end'>
      {secondaryButtonText !== '' && (
        <Button
          id='secondary-btn'
          label={secondaryButtonText}
          type='neutral'
          size='small'
          loading={loading}
          disabled={loading || secondaryButtonDisabled}
          onClick={() => (onNo ? onNo() : undefined)}
        />
      )}
      {thirdButtonText !== '' && (
        <div className='override-btn-min-width'>
          <Button
            id='primary-button'
            size='small'
            disabled={loading || thirdButtonDisabled}
            loading={loading}
            type='filled'
            label={thirdButtonText}
            onClick={() => (onThirdYes ? onThirdYes() : undefined)}
          />
        </div>
      )}
      {primaryButtonText !== '' && (
        <div className='override-btn-min-width'>
          <Button
            id='primary-button'
            size='small'
            disabled={loading || primaryButtonDisabled}
            loading={loading}
            type='filled'
            label={primaryButtonText}
            onClick={() => (onYes ? onYes() : undefined)}
          />
        </div>
      )}
    </div>
  )
}

interface SettingPopupProp {
  modalOpen: boolean
  setModalOpen: React.Dispatch<SetStateAction<boolean>>
  width?: any
  content: React.ReactNode
  showFooter?: boolean
  primaryButtonClick?: any
  secondaryButtonClick?: any
  thirdButtonClick?: any
  primaryButtonText?: string
  secondaryButtonText?: string
  thirdButtonText?: string
  primaryButtonDisabled?: boolean
  secondaryButtonDisabled?: boolean
  thirdButtonDisabled?: boolean

  loading?: boolean
  title?: any
  showHeader: boolean
  height?: boolean
}
export const SettingAddPopup: React.FC<SettingPopupProp> = ({
  modalOpen,
  setModalOpen,
  content,
  width,
  primaryButtonClick,
  secondaryButtonClick,
  thirdButtonClick,
  primaryButtonText,
  secondaryButtonText,
  thirdButtonText,
  primaryButtonDisabled,
  secondaryButtonDisabled,
  thirdButtonDisabled,
  showFooter = true,
  showHeader,
  title = '',
  loading,
  height = false
}) => {
  return (
    <div>
      <DDSModal
        open={modalOpen}
        setOpen={setModalOpen}
        defaultFooter={false}
        onIconClose={() => setModalOpen(false)}
        hideCloseIcon={true}
        style={{ width: width ? width : '' }}
      >
        <div>
          {showHeader && (
            <div
              className='flex justify-between items-center px-[24px] py-[16px] border-b'
              style={{ borderBottomColor: pallete.colors.stroke2 }}
            >
              <DDSTypography.Title
                variant='bold'
                type='h4'
                className='!leading-6'
                color={pallete.colors.textDark4}
              >
                {title}
              </DDSTypography.Title>
            </div>
          )}
          <div
            className={`flex flex-col ${height ? 'h-[250px] 2xl:h-[264px] ' : 'overflow-y-scroll'}  border-b`}
            style={{ borderBottomColor: pallete.colors.stroke2 }}
          >
            {content}
          </div>

          {showFooter && (
            <ModalFooter
              onYes={primaryButtonClick}
              onNo={secondaryButtonClick}
              onThirdYes={thirdButtonClick}
              loading={loading}
              primaryButtonText={primaryButtonText}
              thirdButtonText={thirdButtonText}
              secondaryButtonText={secondaryButtonText}
              primaryButtonDisabled={primaryButtonDisabled}
              secondaryButtonDisabled={secondaryButtonDisabled}
              thirdButtonDisabled={thirdButtonDisabled}
            />
          )}
        </div>
      </DDSModal>
    </div>
  )
}
